import React from "react";
import PropTypes from "prop-types";
import SVG from "theme/components/icons/base/SVG";

const MinusIcon = ({ color, ...props }) => (
    <SVG fill="none" {...props}>
        <path d="M20 10H0M20 10H0" stroke={color} />
    </SVG>
);

MinusIcon.propTypes = {
    color: PropTypes.string,
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

MinusIcon.defaultProps = {
    color: "currentColor",
    viewBox: "0 0 20 20",
    width: "20px",
};

export default MinusIcon;
